// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"31b8e128","209":"978fa121","276":"208809e8","326":"a61eef01","332":"508ff195","500":"4a208ca4","544":"920da888","620":"c284487f","632":"8e54f87e","668":"0ad57a18","832":"8421a9d1","904":"777e6a15"}[chunkId] + ".chunk.js";
};